<ng-container
  *ngIf="startupState().state === 'Done' || !startupState().state; else loading"
>
  <router-outlet></router-outlet>
</ng-container>

<ng-template #loading>
  <div class="data-status">
    <div class="data-status__failed" *ngIf="startupState().state === 'Error'">
      Failed to fetch all required startup data.
    </div>

    <div class="data-status__info" *ngIf="enableStartupLogging">
      <img
        class="data-status__info__logo"
        alt="Brand logo"
        [src]="brand.loginLogo()"
      />
      <div>
        <ng-container *ngFor="let item of startupState().apis | keyvalue">
          <div
            class="data-status-text data-status__info__data {{ item.value }}"
          >
            @if (item.value !== 'Done') {
              <span class="spinner spinner-inline"></span>
            } @else {
              <cds-icon shape="check"></cds-icon>
            }
            {{ item.value }} {{ item.key }}
          </div>
        </ng-container>
      </div>
      <div
        class="data-status-text data-status__info__data Failed"
        *ngIf="startupState().state === 'Error'"
      >
        Failed to fetch all required startup data.
      </div>
    </div>
  </div>
</ng-template>
